/**
 * "Due now" (Lj, Oct 11: "routine reminders show up above the department score heroes … that should be its own card,
 * only visible when a routine or reminder is due … and for now only on the All department"): what needs doing this
 * minute, for one card on the All Home — the routine going (or paused), routines ready or missed today, and reminders
 * that have rung and aren't answered. Empty → the card isn't drawn. Pure — no I/O.
 *
 * routines = ProcessContext's today(now) rows [{ routine, run, state, at }]; activeRun = the run going / paused;
 * tasks (their remindTime), reminders = the stored reminder docs (not approvals — those have their own pill).
 * → { items: [{ kind: 'run' | 'routine' | 'task' | 'reminder', id, title, sub, at, ... }], n }
 */
const DAY = 86400000;
const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : null);

export function dueNow({ routines = [], activeRun = null, tasks = [], reminders = [], now = Date.now(), maxAgeMs = DAY } = {}) {
  const items = [];
  if (activeRun) {
    items.push({ kind: 'run', id: `run:${activeRun.id}`, title: activeRun.routineName || 'Routine', sub: activeRun.pausedAt ? 'paused' : 'going', paused: !!activeRun.pausedAt, run: activeRun, at: num(activeRun.startedAt) || now });
  }
  for (const row of routines || []) {
    if (!row?.routine || !['due', 'missed'].includes(row.state)) continue;
    if (activeRun && row.run?.id === activeRun.id) continue;
    items.push({ kind: 'routine', id: `rt:${row.routine.id}:${row.run?.n || ''}`, title: row.routine.name, sub: row.state === 'due' ? 'ready' : 'missed — start late', state: row.state, routine: row.routine, run: row.run || null, icon: row.routine.look?.icon || null, color: row.routine.look?.color || null, at: num(row.at) || now });
  }
  for (const t of tasks || []) {
    const at = num(t?.remindTime);
    if (!t || t.status !== 'todo' || t.deletedAt || at == null || at > now || now - at > maxAgeMs) continue;
    if (num(t.remindDismissedAt) != null && t.remindDismissedAt >= at) continue;
    items.push({ kind: 'task', id: `tk:${t.id}`, title: t.title, sub: 'reminder', task: t, at });
  }
  for (const r of reminders || []) {
    if (!r || r.source === 'approval' || r.dismissedAt) continue;
    const at = r.status === 'snoozed' ? num(r.snoozedUntil) : num(r.at);
    if (at == null || at > now || now - at > maxAgeMs) continue;
    if (!['scheduled', 'fired', 'snoozed'].includes(r.status)) continue;
    items.push({ kind: 'reminder', id: `rm:${r.id}`, title: r.title || 'Reminder', sub: r.status === 'snoozed' ? 'snoozed — due again' : 'reminder', reminder: r, link: r.link || null, at });
  }
  const order = { run: 0, routine: 1, task: 2, reminder: 2 };
  items.sort((a, b) => order[a.kind] - order[b.kind] || a.at - b.at);
  return { items, n: items.length };
}
